import React, { FunctionComponent, useState } from "react";
import { HeaderProps } from "./types/Header.types";
import "./Header.scss";
import NavTools from "../@shared/NavTools";
import NavMain from "../@shared/NavMain";
import NavTriggers from "../@shared/NavTriggers";
import { Image, useSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { NavItem } from "../@shared/NavMain/types/NavMain.types";
import withErrorCatch from "../../helper/withErrorCatch";

const Header: FunctionComponent<HeaderProps> = (props) => {
  try {
    const { fields } = props;
    if (!fields?.mainNavigation) return <></>;
    const sitecoreContext = useSitecoreContext();
    const [navToolsOpen, navToolsOpenSet] = useState<boolean>(false);
    const [navMainOpen, navMainOpenSet] = useState<boolean>(false);

    return (
      <header className="Header">
        <div className="Header__main">
          <a href={fields.homeItemLink.value.href} className="Header__logo">
            <Image field={fields?.logo.value} />
          </a>
          <NavTriggers
            onNavToolsToggle={() => navToolsOpenSet(!navToolsOpen)}
            onNavMainToggle={() => navMainOpenSet(!navMainOpen)}
          />
          <NavMain
            data={fields?.mainNavigation?.map(({ fields: mainFields }) => {
              const item = {
                title: { value: mainFields.link.value.text },
                subSectionItems: mainFields.subNavigationLinks?.map(
                  ({ fields: subFields, url }) => {
                    const subItem = {
                      title: { value: subFields.link.value.text },
                      subSectionItems: subFields.subNavigationLinks.map
                        ? subFields.subNavigationLinks?.map(
                            ({ fields: subsubFields }) => {
                              return {
                                icon: {
                                  value:
                                    subsubFields?.icon?.fields?.[
                                      "Icon Css Class"
                                    ]?.value,
                                },
                                title: { value: subsubFields.link.value.text },
                                link: subsubFields?.link,
                                subSectionItems: subsubFields.subNavigationLinks
                                  ?.map
                                  ? subsubFields.subNavigationLinks.map(
                                      ({ fields: subsubsubFields }) => ({
                                        icon: subsubsubFields?.icon?.fields?.[
                                          "Icon Css Class"
                                        ],
                                        title: {
                                          value:
                                            subsubsubFields?.link?.value?.text,
                                        },
                                        link: subsubsubFields?.link,
                                      })
                                    )
                                  : [],
                              };
                            }
                          )
                        : [],
                    } as unknown as NavItem;

                    if (subFields.icon?.fields?.["Icon Css Class"].value) {
                      subItem.icon = {
                        value: subFields.icon?.fields?.["Icon Css Class"].value,
                      };
                    }

                    if (
                      !subItem.subSectionItems.length &&
                      (subFields.link.value.href || subFields.url || url)
                    ) {
                      subItem.link = {
                        value:
                          subFields.link.value.href || subFields.url || url,
                        linktype: subFields.link.value.linktype,
                      };
                    }

                    return subItem;
                  }
                ),
              } as NavItem;
              if (
                mainFields.subNavigationLinks.length === 0 &&
                mainFields.link.value.href
              ) {
                item.link = {
                  value: mainFields.link.value.href,
                  linktype: mainFields.link.value.linktype,
                };
              }
              if (mainFields?.additionLink?.value?.text) {
                item.sectionButton = [
                  {
                    title: { value: mainFields.additionLink.value.text },
                    link: {
                      value: mainFields.additionLink.value.href,
                      linktype: mainFields.additionLink.value.linktype,
                    },
                    icon: {
                      value:
                        mainFields.additionalLinkIcon?.fields?.[
                          "Icon Css Class"
                        ]?.value,
                    },
                  },
                ];
              }

              return item;
            })}
            navMainOpen={navMainOpen}
            onClose={() => navMainOpenSet(false)}
          />
        </div>
        {!navMainOpen && (
          <NavTools
            search={{
              label: fields.searchHint,
              link: fields.searchResultPage,
            }}
            navToolsOpen={navToolsOpen}
            languages={fields?.languageSwitcher}
            metaNavigation={fields.metaNavigation.map((item) => item.fields)}
            sitecoreContext={sitecoreContext}
          />
        )}
      </header>
    );
  } catch (error) {
    return <>{(error as Error)?.stack}</>;
  }
};

export default withErrorCatch(Header);
